import { createMachine } from 'common/fsm/createMachine';
import { boolean } from 'yargs';
import { IProcedure } from '../Procedure';
import { IRequest, RequestState } from './Request';

/**
 * FSM Per la gestione delle richieste
 */
export const RequestMachine = createMachine({
  states: Object.values(RequestState),
  actions: ['edit'],
  permissions: {
    [RequestState.Draft]: ['edit'],
    [RequestState.Sending]: [],
    [RequestState.Sent]: [],
    [RequestState.NeedRetry]: [],
    [RequestState.Failed]: ['edit'],
    [RequestState.Cancelled]: [],
    [RequestState.Tested]: []
  },
  getState: (request: IRequest) => request.state,
  transitions: [
    // Invio della domanda
    { from: RequestState.Draft, to: RequestState.Sent },
    { from: RequestState.Draft, to: RequestState.Tested },
    // Nuovo tentativo
    { from: RequestState.Failed, to: RequestState.Sent },
    { from: RequestState.Failed, to: RequestState.Tested }
  ]
});
